import { ChangeDetectorRef, Component, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ModalConfig } from 'src/app/_metronic/partials';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { MenuService } from 'src/app/modules/auth/services/menu.service';
import { environment } from 'src/environments/environment';
import { json } from 'stream/consumers';
import moment from 'moment-timezone';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @Input() public modalConfig: ModalConfig;
  @Input() appHeaderDefaulMenuDisplay: boolean;
  @Input() isRtl: boolean;
  itemClass: string = 'ms-1 ms-lg-3';
  userData: any;
  username: string = '';
  btnClass: string = 'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px';
  userAvatarClass: string = 'symbol-35px symbol-md-40px show menu-dropdown';
  btnIconClass: string = 'fs-2 fs-md-1';
  UserImagePath: string = "./assets/media/logos/default-dark.svg";
  imgUrl = environment.imgUrl;
  showUserImage: boolean = true;
  showUserDp: boolean = true;
  viewMenu: boolean = false;
  roleName: string;
  role: any;
  isVisibleUpgrade = false;
  AllRolesTypess: any[] = [
    { id: 1, name: 'Agent' },
    { id: 2, name: 'Manager' },
    { id: 3, name: 'Admin' },
    { id: 4, name: 'SuperAdmin' },
  ];
  trialDaysLeft: any;
  rate: any;
  mrate: any;
  pricingTiers = [
    { range: '1–14 Users', monthly: 150, yearly: 130 },
    { range: '15–49 Users', monthly: 130, yearly: 110 },
    { range: '50+ Users', monthly: 110, yearly: 90 }
  ];
selectedTierIndex = 1; // Default to 50+ Users
userCount = 1;
  isMonthly = false;
  isAdmin = false;
  @ViewChild('bulkUpgradeModal') private modalBulkUpgradeModal: TemplateRef<NavbarComponent>;
  private ViewBulkUpgradeModal: NgbModalRef;
  private readonly UAE_TIMEZONE = 'Asia/Dubai'; // Dubai timezone

  @ViewChild('bulkQuickStartModal') private modalBulkQuickStartModal: TemplateRef<NavbarComponent>;
  private ViewBulkQuickStartModal: NgbModalRef;

  constructor(
    private router: Router,
    private auth: AuthService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private menuService: MenuService,
    private toastr: ToastrService
  ) {
    this.menuService.menuVisible$.subscribe(visible => {
      this.viewMenu = visible;
      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.autoSelectTier();
    var uData = this.authService.userValue;
    if (uData != null) {
      this.userData = JSON.parse(uData);
      this.username = this.userData.firstName + ' ' + this.userData.lastName;
      if (this.userData.accountType === 'Self-Serve' && this.userData.isUpgraded === false) {
        this.isVisibleUpgrade = true;
        this.trialDaysLeft = this.userData.trialDaysLeft;
        // Schedule task for Dubai 12:00 AM daily
        this.scheduleTaskAtDubaiMidnight();
      }
      if (this.userData.roleId === 3) {
        this.isAdmin = true;
      }
      if (this.userData.isUserLoginFirst === true) {
        this.openBulkQuickModal();
      }
    }
    this.role = this.AllRolesTypess.filter((x: any) => {
      return x.id == this.userData.roleId;
    });
    this.roleName = this.role[0].name;
    this.userData = this.authService.userValue;
    var data = JSON.parse(this.userData);
    this.UserImagePath = `${this.imgUrl}${JSON.parse(this.userData).companyId}/${data.profileImage}`;
    if (data.profileImage == null) {
      this.showUserImage = false;
    } else {
      this.showUserDp = false;
    }
    this.closeMenu();
    this.rate = 150;
    this.mrate = 130;
   
  }
  showMenu() {
    this.menuService.toggleMenu(); 
  }

  closeMenu() {
    this.menuService.hideMenu(); 
  }

  logout() {
    var formValues = {
      username: this.userData.id,
      isMobile: false,
      fcmToken: ""
    };
    this.authService.logoutToken(formValues).subscribe((data: any | undefined) => {
      localStorage.removeItem('user');
      localStorage.removeItem('usercred');
      this.auth.userSubject.next(null);
      localStorage.removeItem('userToken');
      this.auth.companySettingSubject.next(null);
      localStorage.removeItem('companySetting');
      this.router.navigate(['/auth/login'], {
        queryParams: {},
      });
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.menu-sub-dropdown') && !target.closest('.cursor-pointer')) {
      this.menuService.hideMenu();
    }
  }

  openBulkUpgradeModal() {
      this.userCount = 1;
  this.autoSelectTier();
    this.ViewBulkUpgradeModal = this.modalService.open(this.modalBulkUpgradeModal, { windowClass: 'advance-filter-modal', centered: true, scrollable: true });
  }

  closeModal(): void {
    this.ViewBulkUpgradeModal.close(this.modalConfig);
  }

  // Upgrade logic 
  estimatedPrice = 150;
  readonly monthlyRate = 150;
  readonly yearlyRate = 130;

  // selectBilling(monthly: boolean): void {
  //   this.isMonthly = monthly;
  //   this.updateEstimatedPrice();
  // }

  // increaseUsers(): void {
  //   this.userCount++;
  //   this.updateEstimatedPrice();
  // }

  // decreaseUsers(): void {
  //   if (this.userCount > 1) {
  //     this.userCount--;
  //     this.updateEstimatedPrice();
  //   }
  // }
  updateEstimatedPrice(): void {
    let rate: number;

    if (this.userCount >= 50) {
      rate = this.isMonthly ? 110 : 90;
      this.rate = 110;
      this.mrate = 90;
    } else if (this.userCount >= 15) {
      rate = this.isMonthly ? 130 : 110;
      this.rate = 130;
      this.mrate = 110;
    } else {
      rate = this.isMonthly ? 150 : 130;
      this.rate = 150;
      this.mrate = 130;
    }

    this.estimatedPrice = rate * this.userCount;
  }

  sendRequest(): void {
    console.log('Upgrade request submitted:', {
      userCount: this.userCount,
      billingCycle: this.isMonthly ? 'Monthly' : 'Yearly',
      estimatedPrice: this.estimatedPrice
    });

    var uData = this.authService.userValue;
    if (uData != null) {
      this.userData = JSON.parse(uData);
      this.username = this.userData.firstName + ' ' + this.userData.lastName;
      this.SendUpgradeRequestConfirmation(this.userData.companyId, this.userData.email, this.userData.firstName, this.userCount, this.isMonthly ? 'Monthly' : 'Yearly', this.estimatedPrice);
      this.toastr.success('Upgrade request has been sent successfully.');
    }

    this.closeModal();
  }

  SendUpgradeRequestConfirmation(companyId: any, toEmailId: any, firstName: any, noOfUsers: any, billingPrefernce: any, BillingAmount: any) {
    this.authService.SendUpgradeRequestConfirmation(companyId, toEmailId, firstName, noOfUsers, billingPrefernce, BillingAmount).subscribe({
      next: (res: any) => { }
    });
  }

  
  private scheduleTaskAtDubaiMidnight(): void {
    const now = moment();
    const next10amDubai = moment.tz(this.UAE_TIMEZONE).startOf('day').add(12, 'hours'); // 12:00 AM Dubai time
  
    if (now.isAfter(next10amDubai)) {
      // If it's already past 10:10 AM today, schedule it for tomorrow
      next10amDubai.add(1, 'day');
    }
  
    const timeUntilNextRun = next10amDubai.diff(now); // in milliseconds
  
    // Convert to minutes and round to 2 decimal places
    const timeUntilNextRunInMinutes = Math.round(timeUntilNextRun / 1000 / 60 * 100) / 100;

    setTimeout(() => {
      this.runScheduledTask();
      this.scheduleTaskAtDubaiMidnight(); // Re-schedule for next day
    }, timeUntilNextRun);
  } 

  private runScheduledTask(): void {
    // Add the logic for your task that should run daily
    this.refreshTrialPeriod(); // Handles trial day decrement and logout if needed
  }

  private refreshTrialPeriod(): void {
    const usercredString: string | null = localStorage.getItem('usercred');
    if (!usercredString) {
      this.logout();
      return;
    }
  
    const JSONUser = JSON.parse(usercredString);
    const now = Date.now();
  
    if (JSONUser?.trialDaysLeft != null) {
      if (JSONUser.trialDaysLeft > 0) {
        JSONUser.trialDaysLeft -= 1;
        JSONUser.lastRefresh = now;
  
        this.trialDaysLeft = JSONUser.trialDaysLeft;
        localStorage.setItem('usercred', JSON.stringify(JSONUser));
        this.cdr.detectChanges();
  
      } else {
        JSONUser.trialDaysLeft = -1;
        localStorage.setItem('usercred', JSON.stringify(JSONUser));

        this.logout();
      }
    } else {     
      this.logout();
    }
  }

  get selectedTier() {
    return this.pricingTiers[this.selectedTierIndex];
  }

  get pricePerUser() {
    return this.isMonthly ? this.selectedTier.monthly : this.selectedTier.yearly;
  }

  get totalPrice() {
    return this.userCount * this.pricePerUser;
  }

 
 

  selectBilling(isMonthly: boolean) {
  this.isMonthly = isMonthly;
  this.autoSetPricing();
}

  selectTier(index: number) {
  this.selectedTierIndex = index;
  this.autoSetPricing();
}

increaseUsers() {
  this.userCount++;
  this.autoSelectTier(); // re-select based on new count
}

decreaseUsers() {
  if (this.userCount > 1) {
    this.userCount--;
    this.autoSelectTier(); // re-select based on new count
  }
}

autoSelectTier() {
  if (this.userCount >= 50) {
    this.selectedTierIndex = 2;
  } else if (this.userCount >= 15) {
    this.selectedTierIndex = 1;
  } else {
    this.selectedTierIndex = 0;
  }

  this.autoSetPricing(); // this is new
}

autoSetPricing(): void {
  const selected = this.pricingTiers[this.selectedTierIndex];
  this.rate = selected.monthly;
  this.mrate = selected.yearly;
  this.estimatedPrice = this.isMonthly ? selected.monthly * this.userCount : selected.yearly * this.userCount;
}
get usersToNextTier(): number | null {
  if (this.userCount < 15) {
    return 15 - this.userCount;
  } else if (this.userCount < 50) {
    return 50 - this.userCount;
  } else {
    return null; // Already at highest tier
  }
}
get discountPercentage(): number {
  const monthly = this.selectedTier?.monthly;
  const yearly = this.selectedTier?.yearly;
  if (!monthly || !yearly) return 0;
  return Math.round(((monthly - yearly) / monthly) * 100);
}

  openBulkQuickModal() {
    this.closeMenu();
    this.ViewBulkQuickStartModal = this.modalService.open(this.modalBulkQuickStartModal, { windowClass: 'advance-filter-modal', centered: true, scrollable: true,size: 'md' });
  }

  closeQuickModal(): void {
    this.ViewBulkQuickStartModal.close(this.modalConfig);
  }

}
